<template>
    <div class="fill-height d-flex align-center justify-center pa-6 login-page">

            <!-- Form login -->
            <v-card v-if="noLock" class="login-card rounded-xl pa-6" max-width="400" width="100%">
                <v-form ref="form" lazy-validation v-on:keyup.native.enter="checkUtente">

                    <!-- Logo + titolo -->
                    <div class="d-flex flex-column align-center mb-6">
                        <v-img src="@/assets/talk_login.png" width="80" height="80"
                               class="rounded-xl mb-3" contain />
                        <span class="text-h6 font-weight-bold primary--text">Talk App</span>
                    </div>

                    <!-- Campi -->
                    <v-text-field
                        v-model="username"
                        label="Email o Username"
                        placeholder="es. nome@mail.it o 123456-cal01"
                        :rules="[
                            v => !!v || 'campo obbligatorio',
                            v => /[0-9]-[a-z0-9]/.test(v) || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'formato non valido',
                            v => message !== '0' || 'username o password errate',
                            v => message !== 'duplicate_email' || 'email associata a più account, contatta l\'assistenza'
                        ]"
                        outlined rounded dense
                        prepend-inner-icon="mdi-account-outline"
                        autocapitalize="none"
                        class="mb-1"
                    />
                    <v-text-field
                        v-model="password"
                        label="Password"
                        :rules="[v => !!v || 'campo obbligatorio']"
                        :type="show1 ? 'text' : 'password'"
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="show1 = !show1"
                        outlined rounded dense
                        prepend-inner-icon="mdi-lock-outline"
                        class="mb-4"
                    />

                    <!-- Progress -->
                    <v-progress-linear
                        :value="progressValue"
                        :color="progressValue == 0 ? 'transparent' : 'primary'"
                        rounded height="3"
                        class="mb-4"
                    />

                    <!-- Bottone -->
                    <v-btn block depressed rounded large color="primary"
                           :loading="loading" @click="checkUtente">
                        Accedi
                    </v-btn>

                    <!-- Recupera accesso -->
                    <div class="text-center mt-3">
                        <span class="text-caption primary--text" style="cursor:pointer" @click="apriRecupero">
                            Non ricordi le credenziali?
                        </span>
                    </div>

                    <!-- Nuovo utente -->
                    <div class="text-center mt-1">
                        <span class="text-caption primary--text" style="cursor:pointer" @click="apriNuovoUtente">
                            Nuovo utente?
                        </span>
                    </div>

                    <!-- Versione -->
                    <div class="text-center mt-3 opacity-50">
                        <span class="text-caption grey--text">Client VRM {{ applicationVersion }}</span>
                    </div>

                </v-form>
            </v-card>

            <!-- Dialog recupero accesso -->
            <v-dialog v-model="dialogRecupero" max-width="420px">
                <v-card class="rounded-xl pa-4">

                    <!-- STEP 1: email -->
                    <template v-if="stepRecupero === 1">
                        <div class="text-subtitle-2 font-weight-bold primary--text mb-3">Recupera accesso</div>
                        <p class="text-body-2 grey--text mb-3">
                            Inserisci la mail associata al tuo account Talk. Se presente nel sistema riceverai username e password via email.
                        </p>
                        <v-text-field
                            v-model="emailRecupero"
                            label="Indirizzo email"
                            outlined rounded dense
                            prepend-inner-icon="mdi-email-outline"
                            :disabled="loadingRecupero"
                            :rules="[v => !!v || 'campo obbligatorio', v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'email non valida', v => !v.endsWith('@jwpub.org') || 'Non è possibile inviare mail a @jwpub.org: indica un\'altra email']"
                            hide-details="auto"
                            class="mb-3"
                            @input="emailRecupero = emailRecupero.toLowerCase()"
                        />
<div v-if="messaggioRecupero" class="text-body-2 text-center mb-3"
                             :class="messaggioRecupero.ok ? 'success--text' : 'grey--text'">
                            {{ messaggioRecupero.testo }}
                        </div>
                        <div class="d-flex justify-end" style="gap:8px">
                            <v-btn text rounded @click="chiudiRecupero">Chiudi</v-btn>
                            <v-btn v-if="!messaggioRecupero || !messaggioRecupero.ok" color="primary" depressed rounded
                                   :loading="loadingRecupero"
                                   :disabled="!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailRecupero) || emailRecupero.endsWith('@jwpub.org')"
                                   @click="inviaRecupero">
                                Continua
                            </v-btn>
                        </div>
                    </template>

                    <!-- STEP 2: dati manuali -->
                    <template v-else-if="stepRecupero === 2">
                        <div class="text-subtitle-2 font-weight-bold primary--text mb-2">Richiesta assistenza</div>
                        <p class="text-body-2 grey--text mb-3">
                            La tua mail non è nel sistema. Compila i campi e invieremo la richiesta all'amministratore.
                        </p>
                        <v-text-field v-model="emailRecupero"    label="Email"          outlined rounded dense hide-details="auto" class="mb-2" prepend-inner-icon="mdi-email-outline" :disabled="loadingRichiesta" :rules="[v => !v.endsWith('@jwpub.org') || 'Non è possibile inviare mail a @jwpub.org: indica un\'altra email']" @input="emailRecupero = emailRecupero.toLowerCase()" />
                        <v-text-field v-model="nomeRichiesta"    label="Nome"           outlined rounded dense hide-details="auto" class="mb-2" prepend-inner-icon="mdi-account-outline" :disabled="loadingRichiesta" />
                        <v-text-field v-model="cognomeRichiesta" label="Cognome"        outlined rounded dense hide-details="auto" class="mb-2" prepend-inner-icon="mdi-account-outline" :disabled="loadingRichiesta" />
                        <v-text-field v-model="congRichiesta"    label="Congregazione"  outlined rounded dense hide-details="auto" class="mb-2" prepend-inner-icon="mdi-home-outline" :disabled="loadingRichiesta" />
                        <v-text-field v-model="circRichiesta"    label="Circoscrizione" outlined rounded dense hide-details="auto" class="mb-3" prepend-inner-icon="mdi-map-outline" :disabled="loadingRichiesta" />
                        <div v-if="messaggioRichiesta" class="text-body-2 text-center mb-3"
                             :class="messaggioRichiesta.ok ? 'success--text' : 'grey--text'">
                            {{ messaggioRichiesta.testo }}
                        </div>
                        <div class="d-flex justify-end" style="gap:8px">
                            <v-btn text rounded @click="chiudiRecupero">Chiudi</v-btn>
                            <v-btn v-if="!messaggioRichiesta || !messaggioRichiesta.ok" color="primary" depressed rounded
                                   :loading="loadingRichiesta"
                                   :disabled="!nomeRichiesta || !cognomeRichiesta || emailRecupero.endsWith('@jwpub.org')"
                                   @click="inviaRichiesta">
                                Invia richiesta
                            </v-btn>
                        </div>
                    </template>

                </v-card>
            </v-dialog>

            <!-- Dialog nuovo utente -->
            <v-dialog v-model="dialogNuovoUtente" max-width="420px">
                <v-card class="rounded-xl pa-4">
                    <div class="text-subtitle-2 font-weight-bold primary--text mb-2">Richiedi accesso a Talk</div>

                    <template v-if="!messaggioNuovo">
                        <p class="text-body-2 grey--text mb-3">
                            Compila il modulo per richiedere le credenziali di accesso. La richiesta verrà valutata in base alla presenza della tua circoscrizione su Talk.
                        </p>
                        <v-text-field v-model="nuovoEmail"    label="Email"          outlined rounded dense hide-details="auto" class="mb-2" prepend-inner-icon="mdi-email-outline"    :disabled="loadingNuovo" :rules="[v => !!v || 'campo obbligatorio', v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'email non valida', v => !v.endsWith('@jwpub.org') || 'Non è possibile inviare mail a @jwpub.org: indica un\'altra email']" @input="nuovoEmail = nuovoEmail.toLowerCase()" />
                        <v-text-field v-model="nuovoNome"     label="Nome"           outlined rounded dense hide-details="auto" class="mb-2" prepend-inner-icon="mdi-account-outline"   :disabled="loadingNuovo" />
                        <v-text-field v-model="nuovoCognome"  label="Cognome"        outlined rounded dense hide-details="auto" class="mb-2" prepend-inner-icon="mdi-account-outline"   :disabled="loadingNuovo" />
                        <v-text-field v-model="nuovoCong"     label="Congregazione"  outlined rounded dense hide-details="auto" class="mb-2" prepend-inner-icon="mdi-home-outline"      :disabled="loadingNuovo" />
                        <v-text-field v-model="nuovoCirc"     label="Circoscrizione" outlined rounded dense hide-details="auto" class="mb-2" prepend-inner-icon="mdi-map-outline"       :disabled="loadingNuovo" />
                        <v-textarea v-model="nuovoNote" label="Note" placeholder="Indica se vuoi creare una nuova circoscrizione o associarti ad una circoscrizione già esistente su Talk" outlined rounded dense hide-details="auto" class="mb-3" rows="3" :disabled="loadingNuovo" />
                        <div class="d-flex justify-end" style="gap:8px">
                            <v-btn text rounded @click="dialogNuovoUtente=false">Chiudi</v-btn>
                            <v-btn color="primary" depressed rounded
                                   :loading="loadingNuovo"
                                   :disabled="!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(nuovoEmail) || nuovoEmail.endsWith('@jwpub.org') || !nuovoNome || !nuovoCognome || !nuovoCong || !nuovoCirc"
                                   @click="inviaNuovoUtente">
                                Invia richiesta
                            </v-btn>
                        </div>
                    </template>

                    <template v-else>
                        <p class="text-body-2 mb-4" :class="messaggioNuovo.ok ? 'success--text' : 'error--text'">
                            {{ messaggioNuovo.testo }}
                        </p>
                        <div class="d-flex justify-end">
                            <v-btn text rounded @click="dialogNuovoUtente=false">Chiudi</v-btn>
                        </div>
                    </template>
                </v-card>
            </v-dialog>

            <privacy-dialog v-model="dialogPrivacy" :consenso="true" :loading="loadingPrivacy"
                @accetta="accettaPrivacy" @rifiuta="rifiutaPrivacy" />

            <!-- Manutenzione -->
            <v-card v-if="lock" class="login-card rounded-xl pa-8" max-width="400" width="100%">
                <div class="d-flex flex-column align-center text-center">
                    <v-img src="@/assets/talk_login.png" width="72" height="72"
                           class="rounded-xl mb-4" contain />
                    <span class="text-h6 font-weight-bold primary--text mb-2">Talk App</span>
                    <v-icon color="orange" large class="mb-3">mdi-wrench-outline</v-icon>
                    <p class="text-body-2 grey--text">
                        L'app è temporaneamente in manutenzione.<br/>
                        Il servizio verrà ripristinato al più presto.
                    </p>
                </div>
            </v-card>

        </div>
    </div>
</template>

<script>
    import { callService, callPost } from '@/modules/utilities.js'
    import { version } from "/package.json"
    import PrivacyDialog from '@/components/PrivacyDialog.vue'

    export default {
        name: 'Login',
        components: { PrivacyDialog },
        data() {
            return {
                applicationVersion: version,
                username: '',
                codice:'',
                circoscrizione:'',
                show1: false,
                password: '',
                message: '',
                loading: false,
                progressValue: 0,
                lock: false,
                noLock: false,
                server: "",
                dialogPrivacy: false,
                loadingPrivacy: false,
                _pendingLoginData: null,
                dialogRecupero: false,
                stepRecupero: 1,
                emailRecupero: '',
                loadingRecupero: false,
                messaggioRecupero: null,
                nomeRichiesta: '',
                cognomeRichiesta: '',
                congRichiesta: '',
                circRichiesta: '',
                loadingRichiesta: false,
                messaggioRichiesta: null,
                dialogNuovoUtente: false,
                nuovoEmail: '',
                nuovoNome: '',
                nuovoCognome: '',
                nuovoCong: '',
                nuovoCirc: '',
                nuovoNote: '',
                loadingNuovo: false,
                messaggioNuovo: null
            }
        },
        methods: {
            async inviaRecupero() {
                if (!this.emailRecupero) return;
                this.loadingRecupero = true;
                this.messaggioRecupero = null;
                try {
                    const res = await callPost('/api/oratore/recuperaAccesso', { email: this.emailRecupero }, true);
                    if (res?.trovato) {
                        this.messaggioRecupero = { ok: true, testo: 'Credenziali inviate alla mail indicata.' };
                    } else {
                        // mail non trovata → step 2
                        this.stepRecupero = 2;
                    }
                } catch {
                    this.messaggioRecupero = { ok: false, testo: 'Errore durante l\'invio. Riprova.' };
                } finally {
                    this.loadingRecupero = false;
                }
            },
            async inviaRichiesta() {
                this.loadingRichiesta = true;
                this.messaggioRichiesta = null;
                try {
                    const res = await callPost('/api/oratore/richiestaAccesso', {
                        email: this.emailRecupero,
                        nome: this.nomeRichiesta,
                        cognome: this.cognomeRichiesta,
                        congregazione: this.congRichiesta,
                        circoscrizione: this.circRichiesta
                    }, true);
                    this.messaggioRichiesta = { ok: true, testo: res?.messaggio || 'Richiesta inviata.' };
                } catch {
                    this.messaggioRichiesta = { ok: false, testo: 'Errore durante l\'invio. Riprova.' };
                } finally {
                    this.loadingRichiesta = false;
                }
            },
            apriNuovoUtente() {
                this.nuovoEmail = this.username.includes('@') ? this.username.trim().toLowerCase() : '';
                this.nuovoNome = '';
                this.nuovoCognome = '';
                this.nuovoCong = '';
                this.nuovoCirc = '';
                this.nuovoNote = '';
                this.messaggioNuovo = null;
                this.dialogNuovoUtente = true;
            },
            async inviaNuovoUtente() {
                this.loadingNuovo = true;
                this.messaggioNuovo = null;
                try {
                    await callPost('/api/oratore/richiestaAccesso', {
                        email: this.nuovoEmail,
                        nome: this.nuovoNome,
                        cognome: this.nuovoCognome,
                        congregazione: this.nuovoCong,
                        circoscrizione: this.nuovoCirc,
                        note: this.nuovoNote,
                        tipoRichiesta: 'nuovo-utente',
                    }, true);
                    this.messaggioNuovo = { ok: true, testo: 'Richiesta inviata.' };
                } catch {
                    this.messaggioNuovo = { ok: false, testo: 'Errore durante l\'invio. Riprova.' };
                } finally {
                    this.loadingNuovo = false;
                }
            },
            apriRecupero() {
                this.emailRecupero = this.username.includes('@') ? this.username.trim().toLowerCase() : '';
                this.stepRecupero = 1;
                this.messaggioRecupero = null;
                this.dialogRecupero = true;
            },
            chiudiRecupero() {
                this.dialogRecupero = false;
                this.stepRecupero = 1;
                this.emailRecupero = '';
                this.messaggioRecupero = null;
                this.nomeRichiesta = '';
                this.cognomeRichiesta = '';
                this.congRichiesta = '';
                this.circRichiesta = '';
                this.loadingRichiesta = false;
                this.messaggioRichiesta = null;
            },
            loadNativeCredentials() {
                const user = localStorage.getItem('talk_user');
                const pass = localStorage.getItem('talk_password');
                if (user && pass) {
                    this.username = user;
                    this.password = pass;
                }
            },
            async checkUtente() {

                this.message = '';

                if (!this.$refs.form.validate()) return;

                this.loading= true;

                let paramJson;
                const isEmail = this.username.includes('@');
                if (isEmail) {
                    paramJson = {
                        mail: this.username.trim().toLowerCase(),
                        password: this.password,
                        codice: 0,
                        _partition: '',
                    };
                } else {
                    const v = this.username.split('-');
                    paramJson = {
                        codice: v[0],
                        _partition: v[1],
                        password: this.password,
                    };
                }

                this.progressValue='10';
                const output = await callPost('/api/oratore', paramJson, true);
                console.log('[Login] output:', output);

                this.progressValue='40';

                if (output?.errore === 'duplicate_email') {
                    this.message = 'duplicate_email';
                    this.$refs.form.validate();
                    this.loading = false;
                    this.progressValue = 0;
                }
                else if(!output){
                    this.message = '0';
                    this.$refs.form.validate();
                    this.loading = false;
                    this.progressValue = 0;
                }
                else {

                    //imposto lo stato
                    let oratore = output.oratore;
                    this.$store.state.accessToken=output.accessToken;
                    this.$store.state.loginCodice = parseInt(oratore.codice);
                    this.$store.state.loginInputCodice = isEmail ? 0 : parseInt(paramJson.codice);
                    this.$store.state.partition=oratore._partition;
                    this.$store.state.oratore=oratore;
                    this.$store.state.congregazione=oratore.congregazione;
                    this.$store.state.idCircoscrizione=oratore._partition;
                    this.$store.state.idCongregazione = oratore.congregazione.id;
                    this.$store.state.congregazioneCorrente = oratore.congregazione;
                    this.$store.state.isCollaboratore = output.isCollaboratore || false;
                    this.$store.state.onesignalShardAppId = output.onesignalShardAppId || null;

                    let param = [this.$store.state.idCircoscrizione];
                    this.$store.state.circoscrizione = await callService("/api/circoscrizione", param);
                    this.progressValue='80';
                    this.progressValue='100';

                    localStorage.setItem('talk_user', this.username);
                    localStorage.setItem('talk_password', this.password);
                    if (window.HybridWebView) {
                        this.$callMaui('SetLogin', `${this.username}|${this.password}|${this.$store.state.accessToken}`);
                        const _o = oratore;
                        const _ruolo = _o.isAdmin ? 'App-Admin'
                            : _o.isCoordinatore ? 'Coordinatore'
                            : _o.isAssistente  ? 'Assistente'
                            : _o.isSM          ? 'Servo Ministeriale'
                            : _o.isAnziano     ? 'Anziano'
                            : 'Oratore';
                        const _name = `${_o.nome} ${_o.cognome} - ${_ruolo}`;
                        const _shardResult = await this.$callMaui('InitTalkOneSignal', output.onesignalShardAppId || _o._partition);
                        if (_shardResult !== 'RESTART_REQUIRED') {
                            // Delay: dà tempo a OneSignal di completare la subscription dopo InitTalkOneSignal
                            const _tagName = _name, _tagUser = `${_o.codice}-${_o._partition}`;
                            setTimeout(() => {
                                this.$callMaui('SetOneSignalTagsMap', `Name=${_tagName}|UserName=${_tagUser}`);
                            }, 5000);
                        }
                    } else {
                        this.$cookie.set("username", this.username);
                        this.$cookie.set("password", this.password);
                    }
                    // Controlla privacy
                    if (!oratore.privacyOk) {
                        this._pendingLoginData = oratore;
                        this.loading = false;
                        this.dialogPrivacy = true;
                        return;
                    }

                    this._completaLogin(oratore);
                };
            },
            async accettaPrivacy() {
                this.loadingPrivacy = true;
                const oratore = this._pendingLoginData;
                const paramJson = {
                    partition: oratore._partition,
                    username: oratore.codice,
                    token: oratore.token,
                };
                const ok = await callPost('/api/oratore/accettaPrivacy', paramJson);
                this.loadingPrivacy = false;
                if (ok !== false && ok !== null && ok !== undefined) {
                    this.dialogPrivacy = false;
                    this._completaLogin(oratore);
                }
            },
            rifiutaPrivacy() {
                this.dialogPrivacy = false;
                this._pendingLoginData = null;
                this.$store.state.accessToken = null;
                this.progressValue = 0;
            },
            _completaLogin(oratore) {
                this.$store.dispatch('login');
                this.$router.replace({ name: "programma" });
            },
        },
        activated() {
            this.loading = false;
            this.progressValue = 0;
            this.loadNativeCredentials();
        },
        async created() {
            let param = [];
            this.lock = await callService("/api/lockSite", param, true);
            console.log('[Login] lockSite:', this.lock);
            this.noLock = !this.lock;
        },
        mounted() {
            this.server = process.env.VUE_APP_SERVER;
            const savedTheme = localStorage.getItem('user_theme');
            if (savedTheme) {
                this.$vuetify.theme.dark = savedTheme === 'dark';
            } else if (!window.HybridWebView) {
                this.$vuetify.theme.dark = this.$cookie.get('theme') == 'true';
            }
            this.loadNativeCredentials();
            if (!window.HybridWebView) {
                this.username = this.username || this.$cookie.get("username");
                this.password = this.password || this.$cookie.get("password");
            }
        }
    }</script>

<style scoped>
.login-page {
    min-height: 100vh;
    background-color: #F4F6F9 !important;
}
.theme--dark .login-page {
    background-color: #121212 !important;
}
.login-card {
    box-shadow: 0 4px 24px rgba(0,0,0,0.10) !important;
}
.opacity-50 {
    opacity: 0.5;
}
</style>

<style>
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
    -webkit-transition-delay: 9999s;
    transition-delay: 9999s;
}
</style>
